import React from "react";

const Header = () => {
  return (
    <h1 className="font-space flex flex-col text-[#3D6666] tracking-[5px]">
      <span className="text-base ">SPLI</span>
      <span className="text-base ">TTER</span>
    </h1>
  );
};

export default Header;
